import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory } from "react-router-dom";
import { Button } from "twComponents/Button";
import { Form } from "components/FormHookComponents/Form";
import { FormTextArea } from "components/FormHookComponents/FormTextArea";
import { FormDatePicker } from "components/FormHookComponents/FormDatePicker";
import { FormPriceInput } from "components/FormHookComponents/FormPriceInput";
import { FormInput } from "components/FormHookComponents/FormInput";
import { FormRadioGroup } from "components/FormHookComponents/FormRadioGroup";
import { FormRadio } from "components/FormHookComponents/FormRadio";
import { FormAddressBookSelect } from "components/FormHookComponents/FormAddressBookSelect";
import { TransactionValidationSchema as S } from "./validation";
import { transactionValidationSchema as validationSchema } from "./validation";
import { Text } from "components";

export const TransactionForm = () => {
  const history = useHistory();

  const onSubmit = (values: S) => {
    // console.log(values.totalAmount.replace(/[^0-9.]/g, ""));
    // console.log(values.perHeadAmount?.replace(/[^0-9.]/g, ""));
    window.alert(`You've submitted the form: ${JSON.stringify(values, null, 2)}`);
  };

  return (
    <div>
      <Form<S>
        onSubmit={onSubmit}
        resolver={yupResolver(validationSchema)}
        defaultValues={{
          date: undefined,
          type: "purchase",
        }}
        shouldFocusError={false}
        mode="onBlur"
      >
        <div className="flex justify-between items-center">
          <Text className="font-semibold text-xl">Transaction</Text>
          <div className="flex-1 flex justify-end">
            <Button type="button" variant="outline" onClick={() => history.goBack()}>
              Cancel
            </Button>
            <Button type="submit" className="ml-5">
              Submit
            </Button>
          </div>
        </div>
        <div className="grid gap-6 grid-cols-1 md:grid-cols-2 xl:grid-cols-[1fr_1fr_1fr_1fr] mt-3">
          <FormDatePicker<S> label="Date *" name="date" />
          <FormPriceInput<S> label="Total Price *" name="totalAmount" />
          <FormPriceInput<S> label="Price per head" name="perHeadAmount" />
          <FormTextArea<S> label="Description" name="description" resize={false} maxLength={50} rows={1} />
          <FormRadioGroup<S> name="type" label="Transaction Type">
            <FormRadio<S> name="type" label="Purchase" value="purchase" id="purchase" />
            <FormRadio<S> name="type" label="Sale" value="sale" id="sale" className="ml-3" />
          </FormRadioGroup>
          <FormInput<S> name="grossWeight" label="Gross Weight" type="number" />
          <FormInput<S> name="payWeight" label="Pay Weight" type="number" />
          <FormInput<S>
            name="shrinkage"
            label="Shrinkage"
            type="number"
            adornmentLeft={{ label: "%", labelFor: "shrinkage" }}
          />
          <FormAddressBookSelect label="Counter Party" />
        </div>
      </Form>
    </div>
  );
};
